import React from 'react'

const ForbiddenError = () => {
    return (
        <div className="flex items-center justify-center h-screen bg-white p-[50px]">
            <div className="text-center">
                <h1 className="text-[150px] font-bold text-transparent leading-[118px] bg-clip-text bg-gradient-to-r from-purple-600 to-blue-400">
                    403
                </h1>
                <h2 className="text-[30px] font-semibold text-gray-800 mt-4">Oops! Access Denied</h2>
                <p className="max-w-[700px] text-gray-600 mt-2">
                    You do not have permission to access this page. If you believe this is an error, please contact the administrator.
                </p>
                <a href="/" className="mt-6 inline-block px-6 py-3 text-white bg-gray-800 rounded-lg hover:bg-black transition duration-300 shadow-md">
                    Return to Home
                </a>
            </div>
        </div>
    )
}

export default ForbiddenError